import { useMemo } from 'react';
import { DocumentNode } from '@apollo/client';

import useSubjects from './useSubjects';

import { CoreSubject } from '../types';
import { findSubject } from '../utils';

export interface SubjectHookInput {
  courseId: string;
  subjectId: string;

  subjectsTreeFragment: DocumentNode;
}

export interface SubjectHookOutput<TSubject> {
  subject?: TSubject;
  loading: boolean;
}

export default function useSubject<TSubject extends CoreSubject>(input: SubjectHookInput): SubjectHookOutput<TSubject> {
  const { courseId, subjectId, subjectsTreeFragment } = input;
  const { subjects, loading } = useSubjects<TSubject>({ courseId, subjectsTreeFragment });

  const subject = useMemo(() => {
    if (subjects) {
      return findSubject(subjects, subjectId);
    }
    return undefined;
  }, [subjects, subjectId]);

  return {
    loading,
    subject: subject ? (subject as TSubject) : undefined,
  };
}
